import BookListGroup from "components/BookGroup/groups/BookListGroup";
import Divider from "components/ui/Divider";
import Container from "hardcover-ui/components/Container";
import Heading from "hardcover-ui/components/Heading";
import TextLink from "hardcover-ui/components/TextLink";
import { ListSerializersListGroup, PageSerializersBooksShow } from "types/serializers";

export default function TopBookLists({ book, topLists }: { book: PageSerializersBooksShow; topLists: ListSerializersListGroup[] }) {
  if (topLists.length === 0) {
    return <></>;
  }

  return (
    <Container variant="layout" size="md">
      <div className="flex justify-between items-baseline">
        <Heading level={2} size="md">
          Top Lists
        </Heading>
        <TextLink
          href={`/books/${book.slug}/lists`}
          size="sm"
          className="flex space-x-1"
        >
          See all ({book.listsCount.toLocaleString()})
        </TextLink>
      </div>

      <div className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-8 gap-y-12">
        {topLists.map((list) => (
          <BookListGroup
            key={`book-list-${list.id}`}
            list={list}
            activeBook={book}
            size="sm"
          />
        ))}
      </div>

      <Divider size="lg" />
    </Container>
  );
}
